import { inRange } from '../utils/functions/math.mjs'

export default () => {
  document.querySelectorAll(`[data-animation]`).forEach($container => {
    const name = $container.dataset.animation
    window.animations = window.animations || {}
    const animation = window.bodymovin.loadAnimation({
      container: $container,
      path: `/assets/media/${name}.json`,
      renderer: $container.dataset.renderer || 'svg',
      loop: $container.dataset.loop ? $container.dataset.loop === 'true' : true,
      autoplay: $container.dataset.autoplay ? $container.dataset.autoplay === 'true' : true,
      name,
    })
    animation.isActive = false
    window.animations[name] = animation

    let markers = {}

    animation.addEventListener('data_ready', () => {
      markers = animation.animationData?.markers
      const $placeholder = $container.querySelector(`[data-animation-placeholder]`)
      if ($placeholder)
        $placeholder.parentElement.removeChild($placeholder)

      animation.markers = {
        'in': (markers.find(m => m.cm.includes('1')))?.tm,
        'loop': (markers.find(m => m.cm.includes('2')))?.tm,
        'out': (markers.find(m => m.cm.includes('3')))?.tm,
      }

      if (name === 'home') {
        animation.markers = [
          (markers.find(m => m.cm.includes('1')))?.tm,
          (markers.find(m => m.cm.includes('2')))?.tm,
          (markers.find(m => m.cm.includes('3')))?.tm,
        ]
        const $slides = $container.querySelectorAll(`.image-slide`)
        $slides[0].classList.add('active')
        const max = $slides.length - 1
        animation.addEventListener('enterFrame', ({ currentTime }) => {
          let index = animation.markers
            .findIndex(marker => inRange(currentTime, marker, marker + 10))
          if (index === -1) return
          index++
          if (index > max) index = 0

          $slides.forEach(($slide, i) => {
            $slide.classList.toggle('active', i === index)
          })
          $slides[0].parentElement.dataset.currentSlide = index.toString()
        })
      }
    })
  })
}